import { env } from "@/config/env";

export type Platform = "glofox";

/** Platforms with a portal implementation. The home picker appears only when length > 1. */
export const PLATFORMS: Platform[] = ["glofox"];

export function hasMultiplePlatforms(): boolean {
  return PLATFORMS.length > 1;
}

export function resolvePlatform(value: string | undefined): Platform {
  if (value && PLATFORMS.includes(value as Platform)) {
    return value as Platform;
  }

  return "glofox";
}

export function getRequestedPlatform(): Platform {
  return resolvePlatform(env.platform);
}

/** Default portal path when only one platform is available. */
export function getSolePlatformPath(): `/${Platform}` {
  return `/${PLATFORMS[0]}`;
}
